var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: {
        width: "600",
        placement: "right-start",
        trigger: "hover",
        "open-delay": 200
      },
      on: { show: _vm.onPopoverShow }
    },
    [
      _c(
        "div",
        {
          staticStyle: { display: "inline-block" },
          attrs: { slot: "reference" },
          slot: "reference"
        },
        [
          "detail" == _vm.mode && !!_vm.userEntity
            ? _c(
                "span",
                {
                  class: {
                    "van-ellipsis": true,
                    SystemUser: "SystemUser" == _vm.userEntity.type,
                    TjkUser: "TjkUser" == _vm.userEntity.type,
                    TicketTrigger: "TicketTrigger" == _vm.userEntity.type
                  },
                  staticStyle: { cursor: "pointer" }
                },
                [_vm._v(_vm._s(_vm._f("ticketUserLabel")(_vm.userEntity)))]
              )
            : !!_vm.userEntity
            ? _c(
                "span",
                {
                  class: {
                    "van-ellipsis": true,
                    SystemUser: "SystemUser" == _vm.userEntity.type,
                    TjkUser: "TjkUser" == _vm.userEntity.type,
                    TicketTrigger: "TicketTrigger" == _vm.userEntity.type
                  },
                  staticStyle: { cursor: "pointer" }
                },
                [_vm._v(_vm._s(_vm._f("ticketUserLabel_2")(_vm.userEntity)))]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", [
            _c("span", { staticStyle: { "font-size": "20px" } }, [
              _vm._v("用户信息")
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticStyle: { float: "right", "padding-right": "5px" },
                attrs: {
                  title: "个人信息页面",
                  target: "_blank",
                  href: "/ticket-vue/u?id=" + _vm.userEntity.id
                }
              },
              [_vm._v("主页")]
            ),
            _vm._v(" "),
            "TjkUser" == _vm.userEntity.type
              ? _c(
                  "a",
                  {
                    staticStyle: { float: "right", "padding-right": "5px" },
                    attrs: {
                      title: "跳转到 客服资料 页",
                      target: "_blank",
                      href:
                        "/tjkInfoManage/serviceInformation?customerId=" +
                        _vm.userEntity.id
                    }
                  },
                  [_vm._v("客服资料")]
                )
              : _vm._e(),
            _vm._v(" "),
            "TjkUser" == _vm.userEntity.type
              ? _c(
                  "a",
                  {
                    staticStyle: { float: "right", "padding-right": "5px" },
                    attrs: {
                      title: "跳转到 基础报酬 页",
                      target: "_blank",
                      href:
                        "/system/action/salary/getSalaryDetailList?adminValue=flag&url=$url&groupId=" +
                        _vm.userEntity.id
                    }
                  },
                  [_vm._v("基础报酬")]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item_1" }, [
            _c("span", { staticClass: "_left_1" }, [_vm._v("ID:")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.userEntity.id))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item_1" }, [
            _c("span", { staticClass: "_left_1" }, [_vm._v("昵称:")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.userEntity.name))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item_1" }, [
            _c("span", { staticClass: "_left_1" }, [_vm._v("类型:")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("userTypeLabel")(_vm.userEntity.type)))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item_1" }, [
            _c("span", { staticClass: "_left_1" }, [_vm._v("用户名:")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.userEntity.loginName))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item_1" }, [
            _c("span", { staticClass: "_left_1" }, [_vm._v("电话:")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.userEntity.phone))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item_1" }, [
            _c("span", { staticClass: "_left_1" }, [_vm._v("邮箱:")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.userEntity.mail))])
          ]),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-top": "100px" } }, [
            _c("h4", [_vm._v(_vm._s(_vm.eventListTitle))])
          ]),
          _vm._v(" "),
          _vm._l(_vm.ticketEventList, function(each) {
            return _c(
              "div",
              {
                key: each.id,
                staticStyle: {
                  "white-space": "nowrap",
                  "text-overflow": "ellipsis",
                  overflow: "hidden"
                },
                attrs: {
                  title:
                    each.ticketTitle +
                    " " +
                    each.operateContent +
                    " " +
                    (each.assignUserId || "")
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm._f("ticketTime")(each.createdAt)))
                ]),
                _vm._v(" "),
                _c("span", { staticStyle: { color: "DarkGray" } }, [
                  _vm._v("在工单")
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticStyle: { color: "#409eff" },
                    attrs: { href: "/ticket/t/" + each.orderId }
                  },
                  [_vm._v(_vm._s(each.ticketTitle))]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(each.operateContent))]),
                _vm._v(" "),
                each.assignUserId
                  ? _c(
                      "span",
                      [
                        _vm._v("\n                给\n                "),
                        _c("TicketUser", {
                          attrs: { userId: each.assignUserId }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b87289cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b87289cc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketUser.vue
// module id = 708
// module chunks = 75